import React from 'react';
import { bool, object, string, number, func, oneOfType } from 'prop-types';
import useStyles from '../../hooks/useStyles';

TextInput.propTypes = {
	className: string,
	value: oneOfType([string, number]),
	onRef: oneOfType([func, object]),
	validity: bool
};

export default function TextInput({ className, onRef, value, validity, ...rest }) {
	const { input } = useStyles(styles, { validity });
	return <input css={input} className={className} ref={onRef} value={value} {...rest} />;
}

function styles({ css, theme, data: { validity } }) {
	return {
		input: css`
			height: 40px;
			/* below fixes appearance of type search in safari*/
			appearance: textfield;
			padding: 12px 8px;
			border: 1px solid ${validity ? theme.color.success : validity === false ? theme.color.danger : theme.color.muted};
			transition: border-color ${theme.timing.default}, color ${theme.timing.default},
				background-color ${theme.timing.default};
			background-color: ${theme.color.white};
			color: ${theme.color.text};
			border-radius: 4px;
			/* fix for firefox error state */
			box-shadow: none;

			:-webkit-autofill::first-line {
				font-size: 1.4rem;
				font-family: 'Open Sans', sans-serif;
			}

			&:focus {
				border-color: ${theme.color.primary};
			}

			&:disabled {
				opacity: 0.5;
				border-color: ${theme.color.muted};
				background-color: ${theme.color.white};

				&::placeholder {
					opacity: 0.6;
				}
			}

			&::placeholder {
				transition: opacity 0.2s;

				/* Chrome, Firefox, Opera, Safari 10.1+ */
				color: ${theme.color.muted};
				opacity: 1; /* Firefox */
			}

			&::-ms-input-placeholder {
				/* Microsoft Edge */
				color: ${theme.color.muted};
			}
		`
	};
}
